import React, { useEffect, useState } from 'react';
import { Transfer } from 'antd';



const Question5 = ({ data, setData }) => {
    const [targetKeys, setTargetKeys] = useState([]);

    useEffect(() => {
        setTargetKeys([...data.answerVariants].sort((a, b) => parseFloat(a.sortOrder) - parseFloat(b.sortOrder)).filter(x => x.isRight === 1).map(el => el.id));
    }, [data.answerVariants]);

    const onChange = (nextTargetKeys, direction, moveKeys) => {
        console.log('targetKeys:', nextTargetKeys);
        console.log('direction:', direction);
        console.log('moveKeys:', moveKeys);
        let targetArray = [...targetKeys];
        if (direction === 'right') {
            moveKeys.forEach(element => {
                targetArray.push(element);
            });
        }
        else {
            targetArray = [...targetArray].filter(x => !moveKeys.includes(x));
        }
        setData({
            ...data,
            answerVariants: [
                ...data.answerVariants.map(el => {
                    if (targetArray.includes(el.id)) {
                        return { ...el, isRight: 1, sortOrder: targetArray.indexOf(el.id) }
                    }
                    else {
                        return { ...el, isRight: 0 }
                    }
                })
            ]
        });

        setTargetKeys(targetArray);
    };
    return (
        <div>
            <Transfer
                dataSource={[...data.answerVariants].map(el => { return { key: el.id, title: el.answerText } })}
                targetKeys={targetKeys}
                listStyle={{
                    width: 500,
                    height: 500,
                }}
                onChange={onChange}
                render={item => <div key={`item${item.id}`} style={{ padding: 15 }}>{item.title}</div>}
            />
        </div>
    );
}

export default Question5;